import Header from "@/components/header";
import {
  Alert,
  Badge,
  Box,
  Button,
  Card,
  Container,
  Divider,
  Group,
  Image,
  Loader,
  Skeleton,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import "leaflet/dist/leaflet.css";

import CustomStepper from "@/components/stepper";
import { useGetVerification } from "@/services/verification/hooks/useGetVerification";
import { steppersData } from "../type";
import { useNavigate } from "react-router-dom";
import LoadingPillItems from "@/components/loading/loadingPillItems/loadingPillItems";
import useIsSmall from "@/hooks/useIsSmall";

function VerificationResult() {
  const { data, isLoading } = useGetVerification({ isAdmin: true });
  const isSmall = useIsSmall();
  const navigate = useNavigate();
  return (
    <>
      <Header title="تایید هویت" showBack route="/dashboard/profile" />
      <Container w="100%" size="full">
        <Title order={4}> تایید هویت </Title>
      </Container>
      <Container size="sm" w="100%">
        <Stack mih={isSmall ? "calc(100svh - 120px)" : ""} mt="xl">
          <CustomStepper steppers={steppersData} active={3} />
          <Stack flex={1}>
            <Stack flex={1} px="md">
              {data?.status !== 2 ? (
                <Alert>
                  <Stack ta="center">
                    <Text size="xs">
                      اطلاعات شما دریافت شد. تایید هویت شما پس از بررسی های لازم
                      متعابقا اعلام خواهد شد
                    </Text>
                  </Stack>
                </Alert>
              ) : (
                ""
              )}

              <Box>
                <Card withBorder>
                  <Stack justify="space-between" gap="xs">
                    <Group justify="space-between">
                      <Text size="sm">کد ملی</Text>
                      {isLoading ? (
                        <Loader type="dots" size="xs" />
                      ) : (
                        <Badge variant="light">
                          <Text size="xs">{data?.nationalCode}</Text>
                        </Badge>
                      )}
                    </Group>
                  </Stack>
                  <Divider my="md" />
                  {data?.nationalCardImage ? (
                    <Image
                      h={200}
                      w="auto"
                      fit="contain"
                      src={`data:image/jpeg;base64,${data?.nationalCardImage}`}
                    />
                  ) : (
                    <Skeleton h="200" />
                  )}
                  <Divider my="md" />
                  <Stack justify="space-between" gap="xs">
                    <Group justify="space-between">
                      <Text size="sm"> وضعیت</Text>
                      {isLoading ? (
                        <LoadingPillItems count={1} />
                      ) : (
                        <Text size="xs">
                          {data?.status === 1 ? (
                            <Badge color="yellow">در حال بررسی</Badge>
                          ) : data?.status === 2 ? (
                            <Badge color="green">تایید شده </Badge>
                          ) : (
                            <Badge color="red"> رد شده</Badge>
                          )}
                        </Text>
                      )}
                    </Group>
                  </Stack>
                </Card>
              </Box>
            </Stack>
            <Stack p="md">
              <Button onClick={() => navigate("/")}>بازگشت</Button>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

export default VerificationResult;
